import { render, staticRenderFns } from "./staticPage.vue?vue&type=template&id=56ef432a&scoped=true&"
import script from "./staticPage.vue?vue&type=script&lang=js&"
export * from "./staticPage.vue?vue&type=script&lang=js&"
import style0 from "./staticPage.vue?vue&type=style&index=0&id=56ef432a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ef432a",
  null
  
)

export default component.exports